import { Link } from "react-router-dom";
import Error from "../../assets/page404.png";
import "./Page404.scss";

export default function Page404() {
  return (
    <div className="preparing-content-box">
      <img src={Error} className="preparing-img" alt="ready" />
      {/* <div className="preparing-content"> */}
      <h4>이든파이낸셜 정책</h4>
      {window.innerWidth > 758 ? (
        <p className="preparing-content-sub">
          찾을 수 없는 페이지 입니다.
          <br />
          요청하신 페이지가 사라졌거나, 잘못된 경로를 이용하셨습니다.
        </p>
      ) : (
        <p className="preparing-content-sub">
          찾을 수 없는 페이지 입니다.
          <br />
          요청하신 페이지가 사라졌거나,
          <br />
          잘못된 경로를 이용하셨습니다.
        </p>
      )}
      <Link to="/service">돌아가기</Link>
    </div>
  );
}
